import { useEffect, useState } from "react";
import { api } from "./client";

export interface GuideCommand {
  code: string; group: string; forms: string[]; synonyms: string[]; example: string; does: string; window: string;
  example_reply: string; follow_up_reply: string | null;
}
export interface TextGuide {
  phone_e164: string; phone_display: string; groups: { id: string; label: string }[]; commands: GuideCommand[];
  punch_link_ttl_min: number; early_min: number; late_min: number; help_url: string | null; unknown_reply: string;
}

let cached: Promise<TextGuide> | null = null;
export const fetchTextGuide = () => (cached ??= api.get<TextGuide>("/public/text-guide").catch((e) => { cached = null; throw e; }));

export function useTextGuide(): { guide: TextGuide | null; failed: boolean } {
  const [guide, setGuide] = useState<TextGuide | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => { let on = true; fetchTextGuide().then((g) => on && setGuide(g)).catch(() => on && setFailed(true)); return () => { on = false; }; }, []);
  return { guide, failed };
}

/** `?&body=` works on both iOS (expects &) and Android (expects ?). */
export const smsHref = (e164: string, body: string) => `sms:${e164}?&body=${encodeURIComponent(body)}`;
